/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPolicyJobStatusUpdate extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPolicyJobStatusUpdate");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPolicyJobStatusUpdate.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPolicyJobStatusUpdate>): BackgroundJobPayloadForPolicyJobStatusUpdate {
        let obj = Object.assign(new BackgroundJobPayloadForPolicyJobStatusUpdate(), model);
        BackgroundJobPayloadForPolicyJobStatusUpdate.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPolicyJobStatusUpdate>): BackgroundJobPayloadForPolicyJobStatusUpdate {
        if (!model) return null;
        return BackgroundJobPayloadForPolicyJobStatusUpdate.newInstance(<BackgroundJobPayloadForPolicyJobStatusUpdate> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPolicyJobStatusUpdate) {
        if (!obj) return;

        models.BackgroundJobPayloadForPolicyJobStatusUpdate.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPolicyJobStatusUpdate): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPolicyJobStatusUpdate.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.violations_count === undefined) {
            this.violations_count = 0;
        }
        if (this.evaluated_resources === undefined) {
            this.evaluated_resources = 0;
        }
    }

    policy_job_id: string;

    compliance_on_demand_job_id: string;

    violations_count: number;

    status_reason: string;

    policy_details: { [key: string]: string; };

    compliance_status: string;

    service_account_id: string;

    evaluated_resources: number;

}
